import { render, staticRenderFns } from "./StudentPosterIndex.vue?vue&type=template&id=9667e338&scoped=true&"
import script from "./StudentPosterIndex.vue?vue&type=script&lang=js&"
export * from "./StudentPosterIndex.vue?vue&type=script&lang=js&"
import style0 from "./StudentPosterIndex.vue?vue&type=style&index=0&id=9667e338&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9667e338",
  null
  
)

export default component.exports